export default __webpack_public_path__ + "static/media/prothetik_03.0b7eb426.png";